module.exports = __webpack_public_path__ + "img/icon-area.cf81b357.svg";